<template>
  <div class="roleBox fatherHeight">
    <div class="contBox fatherHeight">
      <div class="role-top flex-between">
        <el-form
          :inline="true"
          :model="tableSearch"
          ref="searchForm"
          class="demo-form-inline w-144"
        >
          <el-select
            class="hospital"
            v-model="tableSearch.is_use"
            placeholder="请选择"
          >
            <el-option label="在用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form>
        <el-button @click="handleSearch" class="color-main" type="primary">
          <i class="fa fa-search"></i>查询
        </el-button>
      </div>
      <div class="role-center flex-between">
        <el-alert
          title="带“+”角色：当一个医院有多个院区，并开启了分院模式，这些角色【护士长(+)、医生(+)、主任(+)】的医护人员有权查看或处理各分院的数据"
          type="warning"
          center
          :closable="false"
          show-icon
        />
        <el-button @click="addRole" class="color-green" type="primary">
          <i class="fa fa-plus-circle"></i>新增
        </el-button>
      </div>
      <div class="table" ref="tableBoxRef">
        <el-table
          v-loading="dataListLoading"
          :data="tableData"
          class="table-ellipsis"
          v-if="istable"
          size="small"
          border
          :max-height="tableHei"
        >
          <el-table-column prop="role_name" label="角色名称" />
          <el-table-column label="角色类别">
            <template #default="scope">
              <el-tag size="small">
                {{ scope.row.role_type_name }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="key" label="唯一识别码" /> -->
          <el-table-column label="状态">
            <template #default="scope">
              <el-tag v-if="scope.row.is_use == 1" size="small">在用</el-tag>
              <el-tag v-else size="small" type="danger">停用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="updated_time" label="更新时间" width="160" />
          <el-table-column fixed="right" label="操作" width="80" align="center">
            <template #default="scope">
              <el-link type="primary"
                @click="modParient(scope.row)"
              >
                修改
              </el-link>
              <el-link type="danger"
                @click="delParient(scope.row)"
              >
               删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            :currentPage="pageData.currentPage"
            :page-size="pageData.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :background="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.totalSum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Add ref="addRef" @refreshDataList="getDataList"></Add>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from 'vue'
import service from '@/utils/request'
import { ElMessage, ElMessageBox } from 'element-plus'
import Add from './add.vue'

const tableData = ref([])
const istable = ref(true)
const pageData = reactive({
  currentPage: 1,
  pageSize: 10,
  totalSum: 0,
})
const tableSearch = reactive({
  is_use: 1,
})
const tableBoxRef = ref(null)
const tableHei = ref(0)
const dataListLoading = ref(false)

onMounted(() => {
  istable.value = false
  tableHei.value = tableBoxRef.value.clientHeight - 40
  nextTick(() => {
    istable.value = true
  })
  getDataList()
})
const handleSearch = () => {
  pageData.currentPage = 1
  getDataList()
}
const handleSizeChange = (val) => {
  pageData.pageSize = val
  getDataList()
}
const handleCurrentChange = (val) => {
  pageData.currentPage = val
  getDataList()
}
const getDataList = async () => {
  tableSearch.current = pageData.currentPage
  tableSearch.size = pageData.pageSize
  dataListLoading.value = true
  let res = await service.post('/api/role/list', tableSearch)
  dataListLoading.value = false
  if (res.code === 0) {
    tableData.value = res.data.records
    pageData.totalSum = res.data.total
  }
}
const addRef = ref(null)
const addRole = () => {
  addRef.value.initData()
}
const modParient = (item) => {
  addRef.value.initData(JSON.parse(JSON.stringify(item)))
}
const delParient = (item) => {
  ElMessageBox.confirm('删除后无法撤销，确认删除吗？', '操作提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(async () => {
      let res = await service.post('/api/role/delete', {
        id: item.id,
      })
      if (res.code === 0) {
        ElMessage.success(res.msg)
        getDataList()
      }
    })
    .catch(() => {})
}
</script>

<style scoped lang="scss">
.role-center {
  margin-top: 8px;
  .el-alert {
    width: auto;
    color: #3166ae;
    background: rgba(49, 102, 174, 0.1);
  }
}
.table {
  height: calc(100% - 80px);
}
</style>
